import React, { useState, useEffect } from "react";
import { GetFullURL } from "../../CommonComponents/GlobalConfFiles/URLs";
import { useFetch } from "../../hooks/useFetch";
import { mainArray } from "./Fields";
import { LoadingScreen } from "../../CommonComponents/LoadingScreen/index";
import Button from "react-bootstrap/Button";
import MessageLog from "../../CommonComponents/Messages/MessageLog";
import { useNavigate } from "react-router-dom";
import { FieldsReducer } from "../../CommonComponents/Reducer/Index";
import { useMessage } from "../../hooks/UseMessage";
import { DataGrid } from "@mui/x-data-grid";

export default function BackgroundJobLog(props) {
  let navigate = useNavigate();
  const [_createErrorMessage, _errorMessages, _setErorMessages] = useMessage();
  const [logData, setLogData] = useState([]);
  const [logParam, setLogParam] = useState();
  const [logView, setLogView] = useState(false);
  const [validateClearLog, setValidateClearLog] = useState(false);

  const [
    _requestLog,
    _logData,
    ,
    _errorLog,
    _setErrorLog,
    _successLog,
    _setSuccessLog,
    _loadingLog,
  ] = useFetch(GetFullURL("BackgroundJobLog"), { method: "POST" });

  const [
    _clearLog,
    ,
    ,
    _errorClearLog,
    _setErrorClearLog,
    _successClearLog,
    _setSuccessClearLog,
    _loadingClearLog,
  ] = useFetch(GetFullURL("ClearBackgroundJobLog"), { method: "POST" });

  const [
    _getGeneralDD,
    _GeneralDDData,
    ,
    _errorGeneralDD,
    _setErrorGeneralDD,
    _successGeneralDD,
    _setSuccessGeneralDD,
    _loadingGeneralDD,
  ] = useFetch(GetFullURL("GetGeneralDropDown"), { method: "POST" });

  const operationLoading = _loadingLog || _loadingGeneralDD || _loadingClearLog;

  const onChange = (e) => {
    const {
      target: { value, name },
    } = e;
    let newValue;
    switch (e.target.type) {
      case "number":
        newValue = Number(value);
        break;
      default:
        newValue = value;
        break;
    }
    const newValueObject = { [name]: newValue };
    setLogParam((prevState) => {
      return { ...prevState, ...newValueObject };
    });
  };

  function clearMessages(e) {
    let type = e.target.dataset.type;
    switch (type) {
      case "success":
        _setSuccessLog([]);
        _setSuccessClearLog([]);
        _setSuccessGeneralDD([]);
        break;
      case "error":
        _setErorMessages([]);
        _setErrorClearLog([]);
        _setErrorLog([]);
        _setErrorGeneralDD([]);
        break;
      default:
        break;
    }
  }

  const fieldsState = {
    dropDowns: _GeneralDDData || [],
  };

  useEffect(() => {
    _getGeneralDD({
      data: { backgroundJobName: true, backgroundJobIdentifier: true },
    });
  }, []);

  const mainFieldsToRender = mainArray(fieldsState);

  const mergedFieldData = (field, dataSource, noLable) => {
    let newFieldObject = { ...field, dataSource, onChange };

    return newFieldObject;
  };

  return (
    <>
      <section className="heroCard heroPartner" style={{ height: "auto" }}>
        <div className="container-fluid">
          {operationLoading && <LoadingScreen />}

          <div className="row">
            <div className="col-12">
              {logView ? (
                ""
              ) : (
                <div className="card mb-4">
                  <div className="cardHeader">
                    <h2>All Messages</h2>
                  </div>
                  <div className="cardBody">
                    {mainFieldsToRender.map((field, index) => (
                      <FieldsReducer
                        field={mergedFieldData(field, logParam)}
                        key={index}
                      />
                    ))}
                    <div
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button
                        style={{
                          width: "32%",
                        }}
                        onClick={() => {
                          if (
                            !logParam?.jobName ||
                            logParam?.jobName === "select" ||
                            !logParam?.JobIdentifier ||
                            logParam?.JobIdentifier === "select"
                          ) {
                            logParam.jobName = null;
                            logParam.JobIdentifier = null;
                          }
                          _requestLog(
                            {
                              data: {
                                JobName: logParam?.jobName,
                                JobIdentifier: logParam?.jobIdentifier,
                                JobId: logParam?.jobId,
                                JobDateTime: logParam?.jobDateTime,
                              },
                            },
                            ({ data }) => {
                              if (data.length != 0) {
                                setLogData(data);
                                setLogView(true);
                                setValidateClearLog(false);
                              } else {
                                _createErrorMessage("89");
                              }
                            }
                          );
                        }}
                      >
                        Get Log
                      </Button>
                      <Button
                        onClick={() => {
                          let navigationNextUrl = `/ReportsHome`;
                          navigate(navigationNextUrl);
                        }}
                        style={{
                          width: "32%",
                          background: "#DA1212",
                          borderColor: "#DA1212",
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {logView ? (
              <div className="col-12">
                <div className="mt-0">
                  <div
                    className="custom-table w-100"
                    style={{ height: 750, overflow: "auto" }}
                  >
                    <DataGrid
                      rows={logData || []}
                      columns={[
                        { field: "id", headerName: "ID", width: 100 },
                        {
                          field: "jobName",
                          headerName: "Job Name",
                          width: 110,
                        },
                        {
                          field: "jobIdentifier",
                          headerName: "Job Identifier",
                          width: 110,
                        },
                        { field: "jobId", headerName: "Job ID", width: 110 },
                        {
                          field: "jobDateTime",
                          headerName: "Job DT",
                          width: 190,
                        },
                        {
                          field: "docNumber",
                          headerName: "Doc Number",
                          width: 110,
                        },
                        {
                          field: "logText1",
                          headerName: "Log Text",
                          width: 2000,
                        },
                        {
                          field: "logText2",
                          headerName: "Log Text",
                          width: 2000,
                        },
                        {
                          field: "createdBy",
                          headerName: "Created By",
                          width: 110,
                        },
                        {
                          field: "createdOn",
                          headerName: "Created On",
                          width: 190,
                        },
                      ]}
                      pageSize={100}
                      rowsPerPageOptions={[9]}
                      onSelectionModelChange={""}
                    />
                  </div>
                </div>
                <Button
                  onClick={() => {
                    if (
                      logParam?.jobName ||
                      logParam?.jobIdentifier ||
                      logParam?.jobId ||
                      logParam?.jobDateTime
                    ) {
                      logParam.jobName = null;
                      logParam.jobIdentifier = null;
                      logParam.jobId = 0;
                      logParam.jobDateTime = null;
                    }
                    setLogView(false);
                  }}
                  style={{
                    width: "150px",
                    background: "#DA1212",
                    borderColor: "#DA1212",
                    marginTop: "10px",
                  }}
                >
                  Reset Filter
                </Button>
                <Button
                  onClick={() => {
                    if (
                      logParam?.jobName ||
                      logParam?.jobIdentifier ||
                      logParam?.jobId ||
                      logParam?.jobDateTime
                    ) {
                      logParam.jobName = null;
                      logParam.jobIdentifier = null;
                      logParam.jobId = 0;
                      logParam.jobDateTime = null;
                    }

                    setLogView(false);
                    setValidateClearLog(true);
                  }}
                  style={{
                    marginLeft: "20px",
                    width: "150px",
                    background: "#DA1212",
                    borderColor: "#DA1212",
                    marginTop: "10px",
                  }}
                >
                  Clear Log
                </Button>
              </div>
            ) : (
              ""
            )}
            {validateClearLog ? (
              <div class="d-flex flex-row justify-content-center">
                <div class="p-2">
                  <h2>Are you sure?</h2>
                </div>
                <div class="p-2">
                  <Button
                    onClick={() => {
                      setLogView(false);
                      _clearLog();
                      setValidateClearLog(false);
                    }}
                    style={{
                      marginLeft: "20px",
                      width: "150px",
                      background: "#2ECC71",
                      borderColor: "#2ECC71",
                    }}
                  >
                    Proceed
                  </Button>
                  <Button
                    onClick={() => {
                      setValidateClearLog(false);
                      setLogView(true);
                    }}
                    style={{
                      marginLeft: "20px",
                      width: "150px",
                      background: "#DA1212",
                      borderColor: "#DA1212",
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="col-12 mt-4">
              <MessageLog
                errorMessages={[
                  ..._errorLog,
                  ..._errorMessages,
                  ..._errorClearLog,
                  ..._errorGeneralDD,
                ]}
                successMessages={[
                  ..._successLog,
                  ..._successClearLog,
                  ..._successGeneralDD,
                ]}
                clearMessages={clearMessages}
              ></MessageLog>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
